import { createContext } from 'react';
import { Organisation } from '../services';

export interface OrganisationContextProps {
  organisation: Organisation;
  setOrganisation?: (organisation: Organisation) => void;
}

export const OrganisationContext = createContext<OrganisationContextProps>(
  {} as OrganisationContextProps
);
